export default "__VITE_ASSET__M_tHHHmx__"